import React, { useCallback, useEffect, useState, } from 'react';
import './auth.scss';
import logo from '@Assets/graphic/logo.png';
import { EyeIcon, EyeOffIcon, LockIcon, } from '@Assets/icons';
import { Button, Input, } from 'antd';
import { useTranslation, } from 'react-i18next';
import { apiResetPassword, } from '@Api';
import { AlertError, InfoModal, preventDefault, } from '@Utils';
import { useNavigate, useParams, } from 'react-router-dom';
import { Icon, } from '@Components';

export const ResetPasswordContainer = React.memo(() => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const [loading, ] = useState(false);
  const [errors, setErrors, ] = useState<Array<string>>([]);
  const [password, setPassword, ] = useState<string>('');
  const { username, token, } = useParams<'username' | 'token'>();

  const reset = async () => {
    username && token && password && apiResetPassword(username, token, password)
      .then(msg => {
        InfoModal(t, { content: t(msg || 'PASSWORD_RESET_SUCCESSFUL'), });
      })
      .catch(error => AlertError(t, { content: t(error || 'PLEASE_TRY_AGAIN_LATER'), }));
  };
  
  const validate = useCallback(() => {
    const errors: Array<string> = [];

    if (!username)
      errors.push('Username not found!');

    if (!token)
      errors.push('Token not found!');

    if (password.length < 6)
      errors.push('PASSWORD_INVALID');

    setErrors(errors);
  }, [password, ]);
  
  useEffect(() => {
    validate();
  }, [password, ]);

  return (
    <>
      <div className={'login-bg'}></div>
      <div className={'login-wrp'}>
        <div className={'logo-wrp'} >
          <img src={logo} alt={'Logo'} />
        </div>

        <div className={'form-wrp'}>
          <form onSubmit={preventDefault(reset)}>
            <div className={'form-row'} >
              <span className={'auth-or-txt'}>
                {t('FILL_PASSWORD_TO_RESET')}
              </span>
            </div>
            <div className={'form-row column-dir'} >
              <label className={'form-label'} htmlFor="email">
                {t('PASSWORD')}
              </label>
              <div className={'input-wrp'} >
                <Input.Password
                  type="password"
                  size="large"
                  name="password"
                  onChange={e => {
                    setPassword(e.target.value);
                  }}
                  className={'auth-input'}
                  placeholder=""
                  iconRender={visible => (visible ? <Icon icon={EyeIcon} /> : <Icon icon={EyeOffIcon} />)}
                  prefix={<LockIcon size={24} />} />
              </div>
            </div>
            <div className={'form-row'} >
              <Button loading={loading} onClick={reset} className={'reset-submit-btn'} type="primary" disabled={!!errors.length}>{t('RESET_PASSWORD')}</Button>
            </div>
            <div className={'form-row'} >
              <ul className={'form-error-wrp'}>
                {
                  errors?.map((e, i) => <li key={i}>{t(e)}</li>)
                }
              </ul>
            </div>
          </form>
        </div>

      </div>
    </>
  );
});
